module.exports = __webpack_public_path__ + "img/三天预报.5897ab3c.png";